import { render } from "./bindRolePermiss.vue?vue&type=template&id=a54533aa"
import script from "./bindRolePermiss.vue?vue&type=script&lang=js"
export * from "./bindRolePermiss.vue?vue&type=script&lang=js"

import "./bindRolePermiss.vue?vue&type=style&index=0&id=a54533aa&lang=less"

import exportComponent from "/var/jenkins_home/workspace/saas-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__